<div class="fees-add">
  <!-- Start Add Labor Header -->
  <div class="fees-header mb-0 ui-g-12 p-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-usd-circle header-icon"></i>

        <div class="fees-description width-100p p-relative part-input">
          <app-input id="fee-title" type="text" placeholder="Fees name*" styleClassInput="width-100p" [autoFocus]="true"
            *ngIf="!companyLocalization" [maxLength]="100"
            [theme]="focus?.title || !fees?.title ? 'secondary' : 'light'" [fontSize]="14" [disabled]="isPassThroughFet"
            [errorMessage]="errors.title" [value]="fees.title" [isInvalid]="errors.title"
            (appFocus)="handleFocus('title')" (appBlur)="handleBlur('title')"
            (appChange)="handleChange('title', $event)">
          </app-input>
          <p class="fee-heading" *ngIf="companyLocalization">Fee Details</p>
        </div>
        <i id="fees-close-dialog" class="far fa-times pointer dialog-close" (click)="handleClose()"></i>
      </div>
    </div>
  </div>
  <!-- End Add Labor Header -->

  <p-tabView class="p-0 ui-g-12 tab-panel-underline tab-panel-estimates tab-panel-default"
    (onChange)="selectedTab = $event">
    <p-tabPanel [selected]="selectedTab === 0">
      <ng-template pTemplate="header"> Basic info </ng-template>

      <ng-template pTemplate="content">
        <div class="fees-add-body ui-g-12" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
          <div *ngIf="isFeeAssociationEnabled && openFrom !== 'parts-ordering'"
            class="ui-g-12 p-zero pl-0 mt-3 customer-type-switch"
            [ngClass]="{ 'd-none': openFrom === 'parts-ordering' && feeId }">
            <app-switch-button id="fee-type-switch" valueField="value" paddingClass="p-1" [fontSize]="14"
              [showselectedCircle]="false" [value]="fees?.feeValueType" [showIcons]="true" [options]="feeTypes"
              (appChange)="handleChange('feeValueType', $event)">
            </app-switch-button>
          </div>

          <!-- Pass through taxes -->
          <div class="ui-g-12 p-0 pr-4 pl-2 mt-3" *ngIf="isPassThroughTaxEnable">
            <div class="flex-start-center">
              <app-switch-pill id="passthrough-tax-with-fees" styleClassLabel="fee-label" position="start"
                label="Passthrough tax" [isActive]="fees?.isPassThroughTax"
                (appChange)="handleChange('isPassThroughTax', $event)">
              </app-switch-pill>
            </div>
            <p class="mb-1 font-gray-45">
              <span>Once marked as passthrough tax, the fee item will be treated as tax on Repair Orders (ROs).</span>
            </p>
          </div>

          <!-- Associate items with fees -->
          <div *ngIf="isFeeAssociationEnabled && openFrom !== 'parts-ordering'" class="mt-3">
            <div class="ui-g-12 p-0 pr-4 pl-2 mt-2">
              <div class="flex-start-center">
                <p class="font-700 font-gray-45 mb-0"
                  *ngIf="fees?.feeValueType?.value === 'percent'; else associateItemTemplate">Associate items with fees
                </p>
                <ng-template #associateItemTemplate>
                  <app-switch-pill id="associate-items-with-fees" styleClassLabel="fee-label" position="start"
                    label="Associate items with fees" [isActive]="fees.isAssociateWithFee"
                    (appChange)="handleChange('isAssociateWithFee', $event)">
                  </app-switch-pill>
                </ng-template>
              </div>
              <p class="mb-1 font-gray-45">
                <span *ngIf="fees?.feeValueType?.value === 'percent'; else dollarBaseTemplateText"> This fee is
                  automatically added to the service when an associated item is added to an RO</span>

                <ng-template #dollarBaseTemplateText>For each fees, a default quantity can be selected, or it can be
                  associated with part, labor, and tire items.</ng-template>
              </p>
            </div>
          </div>

          <div class="ui-g-12"
            *ngIf="isFeeAssociationEnabled && (fees?.isAssociateWithFee || fees?.feeValueType?.value === 'percent')">
            <div class="search-ro-wrapper mt-0 mb-1">
              <div class="search-ro-input">
                <app-auto-complete placeholder="Select item from {{ openFrom === 'RO' ? 'RO' : 'catalog' }}"
                  field="title" theme="primary" leftIcon="fal fa-search" styleClassInputWrapper="p-0 pl-1"
                  styleClassInput="p-1" width="500px" [isLoading]="isSearchLoading" [value]="searchQuery"
                  [fontSize]="13" [hasEditableField]="false" [openDropdownOnGetResult]="true" [hasSearchIcon]="true"
                  [closeOnSelection]="true" [suggestions]="itemResults" (appSelect)="onROSelect($event)"
                  (appClear)="onSearchClear($event)" (appCompletedMethod)="searchSuggestion($event)"
                  (appEnter)="onSearchEnter($event)" scrollHeight="288px">
                  <ng-template let-item let-query="query" appTemplate="item">
                    <div class="fee-search-item flex-start-center width-100p">
                      <i *ngIf="item?.type === 'tire'" class="fal fas fa-tire font-gray-75 p-2"></i>
                      <i *ngIf="item?.type === 'part'" class="fal fa-tools font-gray-75 p-2"></i>
                      <i *ngIf="item?.type === 'labor'" class="fal far fa-user-hard-hat font-gray-75 p-2"></i>
                      <i *ngIf="item?.type === 'hazmatFee'" class="fal far fa-usd-circle font-gray-75 p-2"></i>
                      <i *ngIf="item?.type === 'other'" class="fal fa-cog font-gray-75 p-2"></i>

                      <div class="flex-start-center width-100p">
                        <div class="flex-column width-100p">
                          <div class="search-item-header flex-between-center width-100p">
                            <div class="search-title-wrapper">
                              <p class="m-0 text-truncate search-title">
                                <strong>{{ helperService.getLocalizationValue(currentLang, item, 'title') }}</strong>
                              </p>
                              <p class="m-0 text-truncate font-11 font-gray-55 search-description width-100p">
                                {{ item?.description ? item?.description : 'No description' }}
                              </p>
                            </div>

                            <div class="m-0 text-truncate search-price-cost width-100p text-right">
                              <p class="search-price m-0 font-600"><span>Price:</span> {{ item.price || 0 | currency :
                                usd }}</p>
                              <p class="search-cost m-0"><span>Cost:</span> {{ item.cost || 0 | currency : usd }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
              <div class="selected-boxes" *ngFor="let item of selectedItems | slice : 0 : [maxItems]; let i = index">
                <div class="selected-box-inner">
                  <div class="selected-box-header">
                    <h4 tooltipPosition="top" [escape]="false" tooltipStyleClass="no-max-width-tooltip"
                      pTooltip="{{ helperService.getLocalizationValue(currentLang, item, 'title') }} <br>Price: {{ item?.price || 0 | currency : usd }}, Cost: {{ item?.cost || 0 | currency : usd }}">
                      <i *ngIf="item?.type === 'tire'" class="fal fas fa-tire font-gray-75 pr-1"></i>
                      <i *ngIf="item?.type === 'part'" class="fal fa-tools font-gray-75 pr-1"></i>
                      <i *ngIf="item?.type === 'other'" class="fal fa-cog font-gray-75 pr-1"></i>
                      <i *ngIf="item?.type === 'labor'" class="fal far fa-user-hard-hat font-gray-75 pr-1"></i>
                      <i *ngIf="item?.type === 'hazmatFee'" class="fal far fa-usd-circle font-gray-75 pr-1"></i>
                      <span class="text-truncate">{{ helperService.getLocalizationValue(currentLang, item, 'title') }}</span>
                    </h4>
                    <span class="cross-btn"><i class="far fa-times pointer" (click)="removeSelectedRO(item)"></i></span>
                  </div>
                  <div class="selected-box-body">
                    <p class="white-space-nowrap">Cost: {{ item?.cost || 0 | currency : usd }} | Price: {{ item?.price
                      || 0 | currency : usd }}</p>
                  </div>
                </div>
              </div>
              <!-- <div class="selected-box-wrapper"></div> -->
            </div>
            <div class="selected-box-info mb-1">
              <h4 class="font-600" *ngIf="fees?.feeValueType?.value === 'fixed'">Total Qty : {{ totalQuantity }}</h4>
              <h4 class="font-600" *ngIf="fees?.feeValueType?.value === 'percent'">
                Total item cost : {{ totalFixedCost || 0 | currency : usd }} | Total item price : {{ totalFixedPrice ||
                0 | currency : usd }}
              </h4>

              <button (click)="showAllSelectedItems()" *ngIf="selectedItems.length > 8 && !seeMore">See more ({{
                selectedItems.length - 8 }})</button>
              <button (click)="hideSelectedItem()" *ngIf="selectedItems.length > 8 && seeMore">See less</button>
            </div>
          </div>

          <!-- basic info -->
          <ng-container *ngIf="companyLocalization || (isGlobalCategoryEnabled && !isNewCategoriesEnabled)">
            <!-- <ng-container *ngIf="true"> -->
            <p class="font-700 font-gray-45 mb-2 mt-3 pl-2">Basic info</p>
            <div class="fees-body-row flex-start-center mt-0 pl-4">
              <!-- localization should be added on fee FR and Fee EN otherwise it will hide the category dropdown -->
              <div class="ui-lg-8 d-flex" [ngClass]="{'flex-row-reverse': currentLang === 'fr'}" *ngIf="companyLocalization">
                <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-usd-circle"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-input id="labor-title" type="text"
                      placeholder="Fee name (EN){{ currentLang === 'en'? '*' : '' }}" styleClassInput="width-100p"
                      [maxLength]="100" [fontSize]="14" [value]="fees?.title" [isInvalid]="errors.title"
                      (appFocus)="handleFocus('title')" (appBlur)="handleBlur('title')" [errorMessage]="errors.title"
                      (appChange)="handleChange('title', $event)">
                    </app-input>
                  </div>
                </div>
                <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="far fa-usd-circle"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-input id="labor-title" type="text"
                      placeholder="Fee name (FR){{ currentLang === 'fr'? '*' : '' }}" styleClassInput="width-100p"
                      [maxLength]="100" [fontSize]="14" [value]="fees?.titleFR" [isInvalid]="errors.titleFR"
                      (appFocus)="handleFocus('titleFR')" (appBlur)="handleBlur('titleFR')"
                      [errorMessage]="errors.titleFR" (appChange)="handleChange('titleFR', $event)">
                    </app-input>
                  </div>
                </div>
              </div>

              <div *ngIf="isGlobalCategoryEnabled && !isNewCategoriesEnabled" class="fee-field-wrapper flex-start-center qbo-ref-ddl">
                <div class="field-icon flex-center-center">
                  <i class="far fa-tags height-icon"></i>
                </div>
                <div class="field-input">
                  <app-auto-complete id="ac-fees-category" listId="ac-fees-category-list" label="Category"
                    [isShowError]="isShowError" placeholder="Category" field="name" scrollHeight="180px" theme="primary"
                    editableItemIdKey="_id" editFieldLabel="Create Category" [floatingLabel]="true"
                    styleClassInputWrapper="pl-0" styleClassInput="pl-0" [hasEditableField]="true"
                    [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
                    [hasStaticUnassignedFiled]="false" [suggestions]="categoryResults" [listItemFontSize]="14"
                    [fontSize]="14" [value]="fees.category?.name || ''" (appFocus)="showSuggestions('tags')"
                    (appBlur)="handleBlur('category')" (appUpdateItem)="onUpdateItem($event, config?.tags?.fees)"
                    (appChange)="handleChangeCategory(config?.tags?.fees, $event)"
                    (appSelect)="onAutoCompleteSelect($event, 'tags')" (appSave)="saveCategory($event)"
                    (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                    (appClear)="onClearSuggestion('tags')">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                      <div class="tag-item flex-between-center">
                        <div>
                          <span>{{ item?.name }}</span>
                        </div>
                        <div class="tag-item-action flex-end-center">
                          <i class="fas fa-pencil p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                            (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : editItem(item)"></i>
                          <i class="fa fa-trash p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                            (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : deleteCategoryDialog(item)"></i>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="ui-g-12 p-0 pr-4 pl-2 mt-2 mb-3"
            *ngIf="isFeeAssociationEnabled && fees?.feeValueType?.value === 'fixed'">
            <p class="font-700 font-gray-45 mb-0">Pricing</p>
            <p class="mb-1 font-gray-45">The price and cost of the fee will be calculated based on the quantity of the
              associated items on the RO.</p>
          </div>

          <div *ngIf="fees?.feeValueType?.value !== 'percent'">
            <!-- First row -->
            <div class="fees-body-row flex-start-center">
              <!-- Cost -->
              <div class="fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-receipt"></i>
                </div>

                <div class="field-input">
                  <app-input id="fee-cost" theme="primary" type="text" placeholder="Cost*" styleClassInput="width-100p"
                    [selectTextOnFocus]="true" [floatingLabel]="true" [fontSize]="14"
                    [disabled]="fees?.isPassThroughTax" [value]="focus.cost ? fees.cost : (fees.cost | currency : usd)"
                    [allowDecimal]="focus.cost ? true : false" [isInvalid]="errors.cost"
                    (appFocus)="handleFocus('cost')" (appBlur)="handleBlur('cost')"
                    (appChange)="handleChange('cost', $event)">
                  </app-input>
                </div>
              </div>

              <!-- Price -->
              <div class="fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-tag"></i>
                </div>

                <div class="field-input"
                  [ngClass]="{'disabled-autocomplete': (!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) }"
                  tooltipPosition="top"
                  [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) ? 'Please contact admin / store manager to update' : ''">
                  <app-input id="fee-price" theme="primary" type="text" placeholder="Price*"
                    styleClassInput="width-100p" [selectTextOnFocus]="true" [floatingLabel]="true" [fontSize]="14"
                    [disabled]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) "
                    [value]="focus.price ? fees.price : (fees.price | currency : usd)"
                    [allowDecimal]="focus.price ? true : false" [isInvalid]="errors.price"
                    (appFocus)="handleFocus('price')" (appBlur)="handleBlur('price')"
                    (appChange)="handleChange('price', $event)">
                  </app-input>
                </div>
              </div>

              <!-- Default qty -->
              <div class="fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-boxes"></i>
                </div>

                <div class="field-input">
                  <app-input id="fee-default-qty" theme="primary" type="text" placeholder="Default qty*"
                    styleClassInput="width-100p" [allowDecimal]="true" [disabled]="fees.isAssociateWithFee"
                    [selectTextOnFocus]="true"
                    [value]="fees.isAssociateWithFee ? totalQuantity : focus.count ? fees.count : (fees.count | number : '1.2-2')"
                    [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors.count" (appFocus)="handleFocus('count')"
                    (appBlur)="handleBlur('count')" (appChange)="handleChange('count', $event)">
                  </app-input>
                </div>
              </div>
            </div>

            <!-- Second row -->
            <div class="fees-body-row flex-start-center mt-3 justify-content-start">
              <!-- Total cost -->
              <div class="fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <div class="i far fa-receipt"></div>
                </div>

                <div class="field-input">
                  <app-input id="fee-total-cost" theme="primary" type="text" placeholder="Total cost"
                    styleClassInput="width-100p" [disabled]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="fees.totalCost || 0 | currency : usd" [isInvalid]="errors.totalCost">
                  </app-input>
                </div>
              </div>

              <!-- Total price -->
              <div class="fee-field-wrapper flex-start-center ml-3">
                <div class="field-icon flex-center-center">
                  <div class="i far fa-tags"></div>
                </div>

                <div class="field-input">
                  <app-input id="fee-total-price" theme="primary" type="text" placeholder="Total price"
                    styleClassInput="width-100p" [disabled]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="fees.totalPrice || 0 | currency : usd" [isInvalid]="errors.totalPrice">
                  </app-input>
                </div>
              </div>

              <!-- Qbo Reference -->
              <div class="fee-field-wrapper flex-start-center qbo-ref-ddl" *ngIf="isQboConnected">
                <div class="field-icon flex-center-center">
                  <i class="far fa-coins"></i>
                </div>

                <div class="field-input">
                  <app-auto-complete id="fee-qbo-ref" label="QBO item reference" placeholder="QBO item reference"
                    theme="primary" scrollHeight="179px" name="itemRef" styleClassInputWrapper="pl-0"
                    styleClassInput="pl-0" field="title" [value]="fees?.qboRef?.title" [fontSize]="14"
                    [listItemFontSize]="14" [suggestions]="qboItemRefs" [isDropdownIconVisible]="true"
                    [floatingLabel]="true" (appFocus)="handleFocus('qboRef')" (appBlur)="handleBlur('qboRef')"
                    (appClear)="handleClear()" (appSelect)="handleChange('qboRef', $event)"
                    (appCompletedMethod)="handleQboRefSearch($event)">
                  </app-auto-complete>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="fees?.feeValueType?.value === 'percent'">
            <!-- First row -->
            <div class="fees-body-row flex-start-center pl-3">
              <!-- Cost -->
              <div class="ui-g-4 fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-percentage"></i>
                </div>

                <div class="field-input">
                  <app-input id="fee-cost" theme="primary" type="text" placeholder="Percentage Cost*"
                    styleClassInput="width-100p" [selectTextOnFocus]="true" [floatingLabel]="true"
                    [disabled]="fees?.isPassThroughTax" [fontSize]="14" [value]="focus.cost ? fees.cost : fees.cost"
                    [mask]="focus.cost ? '' : 'percent'" suffix="%" [allowDecimal]="focus.cost ? true : false"
                    [isInvalid]="errors.cost" (appFocus)="handleFocus('cost')" (appBlur)="handleBlur('cost')"
                    (appChange)="handleChange('cost', $event)">
                  </app-input>
                </div>
              </div>

              <!-- Price -->
              <div class="ui-g-4 fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-percentage"></i>
                </div>

                <div class="field-input">
                  <app-input id="fee-price" theme="primary" type="text" placeholder="Percentage Price*"
                    styleClassInput="width-100p" [selectTextOnFocus]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="focus.price ? fees.price : fees.price" [mask]="focus.price ? '' : 'percent'" suffix="%"
                    [allowDecimal]="focus.cost ? true : false" [isInvalid]="errors.price"
                    (appFocus)="handleFocus('price')" (appBlur)="handleBlur('price')"
                    (appChange)="handleChange('price', $event)">
                  </app-input>
                </div>
              </div>

              <!-- Qbo Reference -->
              <div class="fee-field-wrapper flex-start-center qbo-ref-ddl" *ngIf="isQboConnected">
                <div class="field-icon flex-center-center">
                  <i class="far fa-coins"></i>
                </div>

                <div class="field-input">
                  <app-auto-complete id="fee-qbo-ref" label="QBO item reference" placeholder="QBO item reference"
                    theme="primary" scrollHeight="179px" name="itemRef" styleClassInputWrapper="pl-0"
                    styleClassInput="pl-0" field="title" [value]="fees?.qboRef?.title" [fontSize]="14"
                    [listItemFontSize]="14" [suggestions]="qboItemRefs" [isDropdownIconVisible]="true"
                    [floatingLabel]="true" (appFocus)="handleFocus('qboRef')" (appBlur)="handleBlur('qboRef')"
                    (appClear)="handleClear()" (appSelect)="handleChange('qboRef', $event)"
                    (appCompletedMethod)="handleQboRefSearch($event)">
                  </app-auto-complete>
                </div>
              </div>
            </div>

            <!-- Second row -->
            <div *ngIf="openFrom === 'RO'" class="fees-body-row mt-3 flex-start-center">
              <!-- Total Fee Cost -->
              <div class="fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <div class="i far fa-receipt"></div>
                </div>

                <div class="field-input">
                  <app-input id="fee-total-cost" theme="primary" type="text" placeholder="Total fee cost"
                    styleClassInput="width-100p" [disabled]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="fees.totalFeeCost || 0 | currency : usd" [isInvalid]="errors.totalFeeCost">
                  </app-input>
                </div>
              </div>

              <!-- Total Fee Price -->
              <div class="fee-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <div class="i far fa-tags"></div>
                </div>

                <div class="field-input">
                  <app-input id="fee-total-price" theme="primary" type="text" placeholder="Total fee price"
                    styleClassInput="width-100p" [disabled]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="fees.totalFeePrice || 0 | currency : usd" [isInvalid]="errors.totalFeePrice">
                  </app-input>
                </div>
              </div>
            </div>
          </div>

          <!-- basic info -->
          <!-- <ng-container *ngIf="isGlobalCategoryEnabled && !isNewCategoriesEnabled">
            <p class="font-700 font-gray-45 mb-2 mt-3">Basic info</p>
            <div class="fees-body-row flex-start-center mt-0" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
              <div class="fee-field-wrapper flex-start-center qbo-ref-ddl">
                <div class="field-icon flex-center-center">
                  <i class="far fa-tags height-icon"></i>
                </div>

                <div class="field-input">
                  <app-auto-complete id="ac-fees-category" listId="ac-fees-category-list" label="Category"
                    [isShowError]="isShowError" placeholder="Category" field="name" scrollHeight="180px" theme="primary"
                    editableItemIdKey="_id" editFieldLabel="Create Category" [floatingLabel]="true"
                    styleClassInputWrapper="pl-0" styleClassInput="pl-0" [hasEditableField]="true"
                    [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
                    [hasStaticUnassignedFiled]="false" [suggestions]="categoryResults" [listItemFontSize]="14"
                    [fontSize]="14" [value]="fees.category?.name || ''" (appFocus)="showSuggestions('tags')"
                    (appBlur)="handleBlur('category')" (appUpdateItem)="onUpdateItem($event, config?.tags?.fees)"
                    (appChange)="handleChangeCategory(config?.tags?.fees, $event)"
                    (appSelect)="onAutoCompleteSelect($event, 'tags')" (appSave)="saveCategory($event)"
                    (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                    (appClear)="onClearSuggestion('tags')">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                      <div class="tag-item flex-between-center">
                        <div>
                          <span>{{ item?.name }}</span>
                        </div>
                        <div class="tag-item-action flex-end-center">
                          <i class="fas fa-pencil p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                            (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : editItem(item)"></i>
                          <i class="fa fa-trash p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                            (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : deleteCategoryDialog(item)"></i>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>
              </div>
            </div>
          </ng-container> -->

          <ng-container *ngIf="isNewCategoriesEnabled">
            <div class="input-basic-info-wrapper input-default-style ui-g-12 pt-3 p-0"
              [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
              <div class="ui-g-12 pb-1">
                <p class="font-700 font-gray-45 mb-0 mt-3">Item classification <span><i
                      class="fas fa-info-circle"></i></span></p>
              </div>

              <div class="ui-g-12 p-0 input-control-container" tooltipPosition="top"
                tooltipStyleClass="tooltip-width-medium text-center"
                [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                <!-- add flag here -->
                <app-category-search subId="1" [type]="'hazmatFee'" [placeholder]="'Search category'"
                  [canEditClassifications]="canEditClassifications"
                  (appSelect)="onSelectCategory($event)"></app-category-search>
              </div>

              <div class="ui-g-12 pt-3 p-0">
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
                    label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="light"
                    [value]="fees?.category?.categoryName" [fontSize]="14" [listItemFontSize]="14"
                    [floatingLabel]="true" [listItemFontSize]="13" [disabled]="!canEditClassifications"
                    [suggestions]="categoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [isLoading]="loader?.category" (appFocus)="handleFocus('category')"
                    (appBlur)="handleBlur('category')" (appSelect)="categoryDropdownSelect('category', $event)"
                    (appCompletedMethod)="onSearchItem('category', $event)"
                    (appClear)="handleClear('category')"></app-auto-complete>
                </div>
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list"
                    field="subCategoryName" label="Standard Subcategory" placeholder="Standard Subcategory"
                    scrollHeight="186px" theme="light" [value]="fees.category?.subCategoryName" [fontSize]="14"
                    [listItemFontSize]="14" [floatingLabel]="true" [listItemFontSize]="13"
                    [suggestions]="subCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [disabled]="!fees.category?.categoryId || !canEditClassifications"
                    (appFocus)="handleFocus('subCategory')" (appBlur)="handleBlur('subCategory')"
                    [isLoading]="loader?.subCategory" (appSelect)="categoryDropdownSelect('subCategory', $event)"
                    (appCompletedMethod)="onSearchItem('subCategory', $event)"
                    (appClear)="handleClear('subCategory')"></app-auto-complete>
                </div>
                <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
                  <app-auto-complete id="standard-fee-type" listId="standard-fee-type-list" field="subSubCategoryName"
                    label="Standard Fee Type" placeholder="Standard Fee Type" scrollHeight="186px" theme="light"
                    [value]="fees.category?.subSubCategoryName" [fontSize]="14" [listItemFontSize]="14"
                    [floatingLabel]="true" [listItemFontSize]="13"
                    [disabled]="!fees.category?.subCategoryId || !canEditClassifications"
                    [suggestions]="subSubCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
                    [isLoading]="loader?.subSubCategory" (appFocus)="handleFocus('subSubCategory')"
                    (appBlur)="handleBlur('subSubCategory')"
                    (appSelect)="categoryDropdownSelect('subSubCategory', $event)"
                    (appCompletedMethod)="onSearchItem('subSubCategory', $event)"
                    (appClear)="handleClear('subSubCategory')"></app-auto-complete>
                </div>
              </div>
            </div>
          </ng-container>


          <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
            <!-- Sales Code -->
            <div *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled" class="ui-g-4 p-0 flex-start-center not-allowed"
              tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
              [pTooltip]="!canEditClassifications && openFrom !== 'RO' ? classificationPrivilegeMsg : (fees?.salesCode?.title === 'Unassigned' || !fees?.salesCode?.title) ? 'Click here to assign sales code' : ''">

              <div class="tire-category width-100p pl-1 pr-2">
                <app-input id="sales-code" type="text" placeholder="Sales Code" theme="primary" [fontSize]="14"
                  name="sales-code" [value]="displaySalesCodeTitle()" [floatingLabel]="true" [maxLength]="50"
                  [disabled]="true"
                  [rightIcon]="!fees?.salesCode?.shortName ? 'fas fa-plus-circle font-warning pointer' : ''"
                  [imgIcon]="fees?.salesCode?.shortName ? 'assets/img/icon/edit-outline.svg' : ''"
                  imgIconClass="pointer" (iconClicked)="openAssignSalesCodeDialog()">
                </app-input>
              </div>
            </div>
          </div>



          <!-- Third row -->
          <p class="font-700 font-gray-45 mb-0 mt-3">General Settings</p>
          <div class="fees-body-row flex-start-center mt-0" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
            <!-- Taxable -->
            <div class="fee-field-wrapper flex-start-center">
              <div class="field-icon flex-center-center">
                <i class="far fa-landmark-alt"></i>
              </div>

              <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                <app-switch-pill id="fee-taxable" label="Taxable" position="end" styleClassLabel="font-gray-35"
                  [fontSize]="12" [isActive]="fees.isTaxable" [disabled]="fees?.isPassThroughTax"
                  (appChange)="handleChange('isTaxable', $event)">
                </app-switch-pill>
              </div>
            </div>

            <!-- Display hours -->
            <div class="fee-field-wrapper flex-start-center">
              <div class="field-icon flex-center-center">
                <i class="far fa-file-invoice"></i>
              </div>

              <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                <app-switch-pill id="fee-display-hour" label="Display qty. & price on estimate & invoice" position="end"
                  styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="fees.displayHoursOnOrder"
                  (appChange)="handleChange('displayHoursOnOrder', $event)">
                </app-switch-pill>
              </div>
            </div>

            <!-- Empty column -->
            <div *ngIf="isCommissionPlanEnabled" class="fee-field-wrapper flex-start-center">
              <div class="field-icon flex-center-center">
                <i class="far fa-sack height-icon"></i>
              </div>

              <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                <app-switch-pill label="Commissionable" [disabled]="fees?.isPassThroughTax" position="end"
                  styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="fees.commissionable"
                  (appChange)="handleChange('commissionable', $event)">
                </app-switch-pill>
              </div>
            </div>

            <!-- Empty column -->
            <!-- <div class="fee-field-wrapper flex-start-center">
      </div> -->
          </div>

          <!-- Fourth row -->
          <div class="fees-body-row flex-start-center">
            <!-- Status -->
            <div class="fee-field-wrapper flex-start-center">
              <div class="field-icon flex-center-center">
                <i class="far fa-info-circle"></i>
              </div>

              <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                <app-switch-pill id="fee-status" position="end" styleClassLabel="font-gray-35"
                  [label]="fees.status ? 'Active' : 'Inactive'" [fontSize]="12"
                  [disabled]="!!orderServiceId && !updateGenericItem" [isActive]="fees.status"
                  (appChange)="handleChange('status', $event)">
                </app-switch-pill>
              </div>
            </div>

            <!-- Display desc -->
            <div class="fee-field-wrapper flex-start-center">
              <div class="field-icon flex-center-center">
                <i class="far fa-boxes"></i>
              </div>

              <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                <app-switch-pill id="fee-display-des" label="Display desc. on estimate & invoice" position="end"
                  styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="fees.displayDescOnOrder"
                  (appChange)="handleChange('displayDescOnOrder', $event)">
                </app-switch-pill>
              </div>
            </div>
          </div>

          <ng-container *ngIf="companyLocalization; else singleDescription">
            <div [ngClass]="{'d-flex flex-column-reverse': currentLang === 'fr'}">
              <div class="fees-body-row flex-start-center mt-2">
                <div class="fee-field-wrapper flex-start-center description-wrapper">
                  <div class="field-icon flex-center-center">
                    <i class="far fa-stream"></i>
                  </div>
                  <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                    <app-textarea id="fee-description-en" textAreaId="fee-description-textarea-en" theme="primary"
                      type="text" placeholder="Fees description (EN)" styleClassInput="width-100p"
                      [floatingLabel]="true" [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14"
                      [value]="fees?.description" [isInvalid]="errors.description"
                      (appFocus)="handleFocus('description')" (appBlur)="handleBlur('description')"
                      (appChange)="handleChange('description', $event)">
                    </app-textarea>
                  </div>
                </div>
              </div>
              <div class="fees-body-row flex-start-center mt-2">
                <div class="fee-field-wrapper flex-start-center description-wrapper">
                  <div class="field-icon flex-center-center">
                    <i class="far fa-stream"></i>
                  </div>
                  <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                    <app-textarea id="fee-description-fr" textAreaId="fee-description-textarea-fr" theme="primary"
                      type="text" placeholder="Fees description (FR)" styleClassInput="width-100p"
                      [floatingLabel]="true" [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14"
                      [value]="fees?.descriptionFR" [isInvalid]="errors.descriptionFR"
                      (appFocus)="handleFocus('descriptionFR')" (appBlur)="handleBlur('descriptionFR')"
                      (appChange)="handleChange('descriptionFR', $event)">
                    </app-textarea>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #singleDescription>
            <div class="fees-body-row flex-start-center mt-2">
              <div class="fee-field-wrapper flex-start-center description-wrapper">
                <div class="field-icon flex-center-center">
                  <i class="far fa-stream"></i>
                </div>
                <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                  <app-textarea id="fee-description" textAreaId="fee-description-textarea" theme="primary" type="text"
                    placeholder="Fees description" styleClassInput="width-100p" [floatingLabel]="true"
                    [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14" [value]="fees?.description"
                    [isInvalid]="errors.description" (appFocus)="handleFocus('description')"
                    (appBlur)="handleBlur('description')" (appChange)="handleChange('description', $event)">
                  </app-textarea>
                </div>
              </div>
            </div>
          </ng-template>
          <div class="fees-body-row flex-start-center mt-2">
            <!-- Description -->
            <div class="fee-field-wrapper flex-start-center description-wrapper">
              <div class="field-icon flex-center-center">
                <i class="far fa-stream"></i>
              </div>

              <div class="field-input" [ngClass]="{'disabled-fet-fee': isPassThroughFet}">
                <app-textarea id="internal-fee-desc" textAreaId="internal-fee-desc-textarea" theme="primary" type="text"
                  placeholder="Internal notes" styleClassInput="width-100p" [floatingLabel]="true"
                  [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14" [value]="fees.internalNotes"
                  [isInvalid]="errors.internalNotes" (appFocus)="handleFocus('internalNotes')"
                  (appBlur)="handleBlur('internalNotes')" (appChange)="handleChange('internalNotes', $event)">
                </app-textarea>
              </div>
            </div>
          </div>

          <div class="fees-add-footer ui-g-12">
            <div class="flex-between-center">
              <div class="footer-left">
                <div>
                  <span *ngIf="!feeId && !orderServiceId && !['catalog', 'cannedService'].includes(openFrom)"
                    [ngClass]="{'disabled-fet-fee': isPassThroughFet}" class="width-100p">
                    <app-checkbox inputId="cb-fee-add-another" label="Add another" [isChecked]="isCreateMultiple"
                      (appChange)="isCreateMultiple = $event"></app-checkbox>
                  </span>

                  <!-- <span *ngIf="orderServiceId && feeId" class="width-100p" [ngClass]="{ invisible: !isOpenFromPO && (isLocal || !orderServiceId) }">
            <app-checkbox
              inputId="cb-part-add-another"
              label="Also update fee across application"
              [isChecked]="updateGenericItem"
              (appChange)="updateGenericItem = $event; fees.status = defaultActiveState"
            >
            </app-checkbox>
          </span> -->
                </div>
              </div>

              <div class="footer-right">
                <button id="fee-cancel-btn" class="btn btn-border pointer btn-width mr-2"
                  (click)="handleClose()">Cancel</button>

                <button id="fee-save-btn" class="btn btn-primary btn-submit btn-width" tooltipPosition="top"
                  [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
                  [disabled]="isSaving || isLoading || isFinalizedRo || isLockedRO || isPassThroughFet"
                  (click)="handleSubmit()">
                  <span [ngClass]="{ 'pr-2': isSaving || isLoading }">Save</span>
                  <i *ngIf="isSaving || isLoading" class="far fa-spinner rotate"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel [selected]="selectedTab === 1">
      <ng-template pTemplate="header"> Activity logs </ng-template>
      <ng-template pTemplate="content">
        <div class="activity-logs">
          <div class="catalog-activity-wrapper">
            <!-- Activity logs -->
            <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
              <div *ngFor="let activityLog of activityLogs">
                <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
              </div>
            </div>

            <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
              <p>There are no activity logs.</p>
            </div>

            <!-- Filter wrapper -->
            <!-- <div hidden class="filter-ddl-wrapper">
              <div class="dropdown">
                <div class="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Filter &nbsp;
                  <i *ngIf="isFilterLoading" class="fal fa-spinner rotate"></i>
                  <span *ngIf="filterOption?.length" class="filter-count-bubble">{{ filterOption?.length }}</span>
                </div>

                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                  <ul class="catalog-list-filter">
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox
                        label="Item history"
                        [disabled]="isFilterLoading"
                        [isChecked]="filterOptionModel.itemHistory"
                        [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'catalog-item')"
                      >
                      </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox
                        label="Purchase history"
                        [disabled]="isFilterLoading"
                        [isChecked]="filterOptionModel.purchaseHistory"
                        [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'ci-purchase-history-po')"
                      >
                      </app-checkbox>
                    </li>
                    <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                      <app-checkbox
                        label="Selling history"
                        [disabled]="isFilterLoading"
                        [isChecked]="filterOptionModel.sellingHistory"
                        [fontSize]="12"
                        (appChange)="onCheckboxChange($event, 'ci-sale-history-ro')"
                      >
                      </app-checkbox>
                    </li>
                  </ul>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>